import { Button, CircularProgress, Stack } from '@mui/material';
import { Component } from 'react';

export default class ApuracaoControls extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let { user, apurado, loading, onPdfClick, onApurarClick, onSendEmailClick } = this.props;
        return (
            <Stack>
                {!loading ?
                    <Stack direction="row" gap={1} justifyContent="flex-end">
                        {!apurado && <Button onClick={onApurarClick} size="small" color="btnStyle" variant="contained" disableElevation>Apurar!</Button>}
                        <Button size="small" onClick={onPdfClick} color="btnStyle" variant="contained" disableElevation>Abrir PDF</Button>
                        {apurado && user?.isAdmin && <Button size="small" color="btnStyle" variant="contained" disableElevation onClick={onSendEmailClick}>Enviar por e-mail</Button>}
                    </Stack> :
                    <Stack direction="row" gap={1} justifyContent="flex-end"><CircularProgress size={20} sx={{ mr: 13 }} /></Stack>
                }
            </Stack>
        );
    }
}
